import * as React from 'react';
import * as qs from 'qs';

interface AppendQueryStringOptions {
  overwrite?: boolean;
}
const appendQueryString = (href: string, data: Record<string, unknown>, options: AppendQueryStringOptions = {}) => {
  const [url, queryStr] = href.split('?');
  const value = (
    options.overwrite
      ? { ...(qs.parse(queryStr)), ...data }
      : { ...data, ...(qs.parse(queryStr)) }
  );
  return url + qs.stringify(value, { addQueryPrefix: true });
};
interface TrackingURIParams {
  sectionId: string;
  sectionItemIdx: number | undefined;
  sectionArg?: string;
}
export const getTrackingURI = (inputURI: string, params: TrackingURIParams) => {
  const {
    sectionId,
    sectionItemIdx,
    sectionArg,
  } = params;

  return appendQueryString(inputURI, {
    _rdt_sid: sectionId.replace(/-/g, '_'),
    _rdt_idx: sectionItemIdx,
    _rdt_arg: sectionArg || undefined,
  }, { overwrite: true });
};

const pickTargetByThumbnail = (elem: HTMLElement) => (
  elem.className && elem.className.includes('RSGBookThumbnail_CoverImage_Shadow')
)
const pickTargetByTitle = (elem: HTMLElement) => (
  elem.className && elem.className.includes('RSGBookMetadata_Title')
)
const checkIsTarget = (target: HTMLElement) => [
  pickTargetByThumbnail,
  pickTargetByTitle,
].reduce((p: boolean, picker) => (
  p ? p : picker(target)
), false)

interface Props {
  href: string;
  sectionId: string;
  sectionItemIdx: number | undefined;
}
const BookTrackingWrapper: React.FC<Props> = (props) => {
  const { href, sectionId, sectionItemIdx, children } = props;
  return (
    <div
      onClick={(e) => {
        if (href && checkIsTarget(e.target as HTMLElement)) {
          e.preventDefault();
          const trackingURI = getTrackingURI(href, {
            sectionId,
            sectionItemIdx,
          })
          window.location.href = trackingURI;
        }
      }}
    >
      {children}
    </div>
  )
}

export { BookTrackingWrapper };



// WEBPACK FOOTER //
// ./components/book/BookTrackingWrapper.tsx